import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Dialog, Fab, Button, TextField, Grid, Box } from '@material-ui/core';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context'; 
import AddIcon from '@material-ui/icons/Add';
import PlatfromSelect from './PlatfromSelect';
import PublishIcon from '@material-ui/icons/Publish';
import useFocus from 'src/hook/useFocus';
import clsx from 'clsx';
import {usePreferenceContext} from 'src/context/PreferenceContext';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    background: 'white',
  },
  fabAdd: {
    position: 'fixed',
    bottom: theme.spacing(2.5),
    right: theme.spacing(2),
    zIndex: 1000,
  },
  showkeyboard: {
    position: 'fixed',
    bottom: 0,
    left: 0,
  },
  dialog: {
  
    '& MuiDialogScrollPaper': {
      alignItems: 'flex-end',
    },
    '& .MuiDialog-scrollPaper': {
      alignItems: 'flex-end',
    },
    '& .MuiBackdrop-root': {
      backgroundColor: 'rgb(0 0 0 / 15%)',
    // display:"none"
    },
    '& .MuiDialog-paperWidthFalse': {
      width: '100%',
      maxWidth: 'unset',
      margin: 0,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
  },
  dNone: {
    display: 'none',
  },
  publicButton: {
    fontSize: 16,
    width: 20,
    minWidth: 'unset',
    marginLeft: theme.spacing(1),
  },
  publishIcon: {
    fontSize: 16,
  },
  container: {
    alignItems: 'center',
  },
}));

export default function BasicTextFields({ fishlistRef, onPaste, ...props }) {
  const classes = useStyles();
  const [inputRef, setInputFocus] = useFocus();
  const {addFruit,addFruits} = useHarvestingContext();

  const [pasteLock, setPasteLock] = useState(false);

  const [name, setName] = useState('');
  const [platform, setPlatform] = useState('Facebook');
  const [doubleClickBlock, setDoubleClickBlock] = useState(false);
  const [open, setOpen] = React.useState(window.location.hash === '#type');

  const screenWidth = window.innerWidth;
  const smallBreakPoint = 600;

  const {setFruitsTab}= usePreferenceContext();


  useEffect(() => {
    const onHashChange = () => setOpen(window.location.hash === '#type');
    if (window.location.hash === '#type') {
      setDoubleClickBlock(true);
    }
    window.addEventListener('hashchange', onHashChange);
    return () => {
      window.removeEventListener('hashchange', onHashChange);
    };
  }, []);

  const handleClickOpen = () => {
    setDoubleClickBlock(true);
    window.location.hash = '#type';
    // window.scrollTo(0, 800);
    // fishlistRef.current.scrollIntoView();
  };

  const handleClose = () => {
    if (doubleClickBlock) {
      setDoubleClickBlock(false);
      window.history.back();
    }
  };
  const publish = () => {
    setInputFocus();
    setName('');
    if (name !== '') {
      addFruit( {
        name,
        others: '',
        platform: platform,
        methodType: 'mannual'
      });
    }
  };
  return (
    <>
      {/* <div>
        <PlatfromSelect />
      </div> */}

      <TextField
        InputProps={{
          startAdornment: (
            <PlatfromSelect value={platform} setValue={setPlatform} />
          ),
        }}
        onPaste={(x) => {
          //TODO: INVESTIGATE THIS PASTE METHOD
          let htmlText = x.clipboardData.getData('text/html');

          if (htmlText === '') {

            htmlText = x.clipboardData.getData('text/plain');
            const nameArr = htmlText
              .split('\n')
              .filter((name) => name.trim() !== '')
              .map((name) => {
                return {
                  name,
                  others: '',
                  platform: platform,
                };
              });
            addFruits(nameArr);
          } else {
            onPaste(x);
          }
          setPasteLock(true);
        }}
        onClick={screenWidth < smallBreakPoint ? handleClickOpen : null}
        fullWidth
        value={name}
        onChange={(e) => {
          if (!pasteLock) {
            setName(e.target.value);
          } else {
            setPasteLock(false);
            setName('');
          }
  
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            setFruitsTab('Available');
            publish();
          }
        }}
        {...props}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        className={classes.dialog}
        maxWidth={false}
      >
        <Grid container className={classes.container} >
          <Grid item xs>
            <TextField
              autoFocus
              margin="dense"
              fullWidth
              value={name}
              onPaste={(x) => {
                let htmlText = x.clipboardData.getData('text/html');
                if (htmlText === '') {
                  htmlText = x.clipboardData.getData('text/plain');
                  const nameArr = htmlText
                    .split('\n')
                    .filter((name) => name.trim() !== '')
                    .map((name) => {
                      return {
                        name,
                        others: '',
                        platform: platform,
                      };
                    });
                  addFruits(nameArr);
                } else {
                  onPaste(x);
                }
                setPasteLock(true);
              }}
              onChange={(e) => {
                if (!pasteLock) {
                  setName(e.target.value);
                } else {
                  setPasteLock(false);
                  setName('');
                }
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  setFruitsTab('Available');
                  publish();
                }
              }}
              placeholder="Fish names..."
              inputRef={inputRef}
              InputProps={{
                startAdornment: (
                  <PlatfromSelect value={platform} setValue={setPlatform} />
                ),
              }}
            />
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              className={classes.publicButton}
            >
              <PublishIcon
                className={classes.publishIcon}
                onClick={() => publish()}
              />
            </Button>
          </Grid>
        </Grid>
      </Dialog>

      <Box display={{ xs: 'block', sm: 'none' }}>
        <Fab
          color="primary"
          className={clsx(
            classes.fabAdd,
            open ? classes.dNone : classes.fabAdd
          )}
          onClick={handleClickOpen}
        >
          <AddIcon />
        </Fab>
      </Box>
    </>
  );
}
